var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMainIcon5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5L6 1l4.5 8 5-8L20 9l4.5-8 5 8L34 1l5 8 4.5-8 5 8 5-8L58 8.5",
    stroke: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1OSIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDU5IDExIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0xIDguNUw2IDFMMTAuNSA5TDE1LjUgMUwyMCA5TDI0LjUgMUwyOS41IDlMMzQgMUwzOSA5TDQzLjUgMUw0OC41IDlMNTMuNSAxTDU4IDguNSIgc3Ryb2tlPSIjZmZmIi8+Cjwvc3ZnPg==";
export { SvgMainIcon5 as ReactComponent };